import { Button, Col, Form, Input, Row, Select, Space } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { getLearners } from '../../services/learnerService';
import LearnerAdd from './LearnerAdd';
import LearnersTable from './LearnersTable';

const { Option } = Select;

const PAGE_SIZE = 20;

function Learners() {
  const [form] = Form.useForm();

  const totalCount = useRef(null);
  const [learner, setLearner] = useState([]);
  const [status, setStatus] = useState('LOADING');
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [searchParams, setSearchParams] = useState(false);
  const [pagination, setPagination] = useState({
    pageNo: 1,
    pageSize: PAGE_SIZE,
  });

  useEffect(() => {
    fetchData(pagination.pageNo, pagination.pageSize, searchParams);
  }, [pagination, searchParams]);

  const fetchData = (pageNo, pageSize, param) => {
    console.log('Getting learners from backend');
    setStatus('LOADING');
    getLearners(pageNo, pageSize, param)
      .then((response) => {
        console.log('Received the response from the data', response);
        console.log('Learners data', response.data.paginatedList);
        totalCount.current = response.data.totalCount;
        setLearner(response.data.paginatedList);
        setStatus('SUCCESS');
      })
      .catch((error) => {
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
        setStatus('ERROR');
      });
  };

  function onPaginationChange(data) {
    setPagination({
      pageNo: data.current,
      pageSize: data.pageSize,
    });
  }

  function onSearch(data) {
    setSearchParams({ [data.param]: data.val })
  }

  function onReset() {
    form.resetFields();
    fetchData(1, PAGE_SIZE);
  }

  function toggleAddModal() {
    setIsAddModalOpen((prev) => !prev);
  }

  return (
    <div>
      <Space size="large">
        <h1>Learners</h1>
      </Space>
      <Row justify="space-between">
        <h3>Total {totalCount.current} Record(s)</h3>
        <Button type="primary" onClick={toggleAddModal}>
          Add Learner
        </Button>
      </Row>
      <section className="grey-section">
        <Form form={form} onFinish={onSearch} initialValues={{ param: 'name' }}>
          <Row gutter={16}>
            <Col span={4}>
              <Form.Item name="param" rules={[{ required: true }]}>
                <Select placeholder="Search by...">
                  <Option value="name">Name</Option>
                  <Option value="learnerId">Learner Id</Option>
                  <Option value="email">Email</Option>
                  <Option value="phoneNumber">Phone Number</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item name="val" rules={[{ required: true }]}>
                <Input placeholder="Enter the search term..." />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Search
                </Button>
                <Button htmlType="button" onClick={onReset}>
                  Reset
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </section>
      <section>
        <LearnersTable
          data={learner}
          onPaginationChange={onPaginationChange}
          loading={status === 'LOADING' ? true : false}
          totalCount={totalCount.current}
        />
      </section>
      <LearnerAdd isOpen={isAddModalOpen} toggle={toggleAddModal} />
    </div>
  );
}

export default Learners;
